import { useCallback } from "react";
import { useSelector } from "react-redux";
import { getQueryData } from "src/helpers/helpers";
import useFetchAsync from "src/hooks/useFetchAsync";
import { deleteReq, useGet, usePatch, usePost } from "src/http-clients/clients";
import { getActiveStoreId } from "src/redux/selectors/app";

export const useCreateInventory = () => {
  const activeStore = useSelector(getActiveStoreId);
  return usePost(`/users/${activeStore}/clients/create-client`);
};

export const useGetInventory = ({
  length,
  page,
  search,
}: {
  length: number;
  page: number;
  search?: string;
}) => {
  const activeStore = useSelector(getActiveStoreId);
  const offset = page === 1 ? 0 : (page - 1) * length;
  const queryData = getQueryData({ length, offset, search });
  const data = useGet(`/users/stores/${activeStore}/inventory/requests`);
  return data;
};

export const useGetInventoryData = (clientId: number) => {
  const activeStore = useSelector(getActiveStoreId);
  return useGet(
    clientId ? `/users/${activeStore}/clients/client/${clientId}` : null
  );
};

export const useUpdateInventory = (clientId: number) => {
  const activeStore = useSelector(getActiveStoreId);
  return usePatch(`/users/${activeStore}/clients/client/${clientId}`);
};

export const useDeleteInventory = () => {
  const activeStore = useSelector(getActiveStoreId);
  const deleteData = useCallback(
    (clientId: number) => {
      return deleteReq(`/users/${activeStore}/clients/client/${clientId}`);
    },
    [activeStore]
  );
  return useFetchAsync(deleteData);
};
